module.exports = "/desktop-app/assets/img/mailbox-bg.svg?7ff28c2ccf4c1be5fffea766b344cbdd";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/mailbox-bg.svg
// module id = eOu7
// module chunks = 1